import React, { FC } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import { LoaderSizeProps } from 'react-spinners/helpers/props';

import UtilFunctions from '~utils/functions';
import * as Styles from './_customClipLoader.module.scss';

type TCustomClipLoaderProps = LoaderSizeProps & {
    blackBorder?: boolean;
    className?: string;
}

const CustomClipLoader: FC<TCustomClipLoaderProps> = ({
    blackBorder,
    className,
    ...props
}) => {
    const styles = UtilFunctions.Styles.concatClassNames([
        Styles['clip-loader'],
        (blackBorder ? Styles['black-border'] : ''),
        (className ? className : ''),
    ]);

    return (
        <ClipLoader
            className={styles}
            {...props}
        />
    );
};

export default CustomClipLoader;
